
    import Vue from "vue";
    import {Component, Model, Prop, Watch} from "vue-property-decorator";

    @Component({
        model: {
            prop: 'modelValue',
            event: 'input'
        }
    })
    export default class Checkbox extends Vue {
        //Model
        @Model("input", { type: Boolean, default: undefined }) modelValue: boolean;

        //Props
        @Prop({
            type: String,
            default: function () {
                return 'checkbox-id-' + (<any> this)._uid;
            }
        }) readonly id: string;
        @Prop({ default: null, type: String }) readonly name: string;
        @Prop({default: true, type: Boolean}) readonly value: any;
        @Prop({ default: null, type: String }) readonly className: string;
        @Prop({
            type: Boolean,
            default: false
        }) readonly checked: boolean;
        @Prop({
            type: Boolean,
            default: false
        }) readonly required: boolean;
        @Prop({
            type: Boolean,
            default: false
        }) readonly disabled: boolean;

        //Computed
        get state() {
            if (this.modelValue === undefined) {
                return this.checked;
            }
            if (Array.isArray(this.modelValue)) {
                return this.modelValue.indexOf(this.value) > -1;
            }
            return !!this.modelValue;
        }

        //Methods
        onChange() {
            this.toggle();
            this.$emit('checked', this.state);
        }

        toggle() {
            let value;
            if (Array.isArray(this.modelValue)) {
                value = this.modelValue.slice(0);
                if (this.state) {
                    value.splice(value.indexOf(this.value), 1);
                } else {
                    value.push(this.value);
                }
            } else {
                value = !this.state;
            }

            this.$emit('input', value);
        }

        @Watch("checked")
        onCheckedChanged(val: boolean) {
            if (val !== this.state) {
                this.toggle();
            }
        }
    }
